export default __webpack_public_path__ + "static/media/roles.ac4725e0.svg";